export default "__VITE_ASSET__3303aa4f__";